import { CellClassParams } from 'ag-grid-community';
import { safeRound } from 'src/utils/math';

export const validateSumIs100Percent = ({ column, node, value }: CellClassParams): boolean => {
    const colId = column.getColId();
    const parentData = Number(node.parent?.aggData?.[colId]);

    if (node.group) {
        return safeRound(value) !== 100;
    }

    if (!Number.isNaN(parentData)) {
        return safeRound(parentData) !== 100;
    }

    return false;
};

export const validateSumIs100PercentProductLineSplit = ({ column, node, value }: CellClassParams): boolean => {
    const colId = column.getColId();
    const parentData = node.parent?.aggData?.[colId];

    // Recurse all the way to the top group for productline split - this handles both the row grouping and the sum row
    if (node.parent && typeof parentData === 'number') {
        return validateSumIs100PercentProductLineSplit({
            column,
            node: node.parent,
            value: parentData,
        } as CellClassParams);
    }

    // Validate the value for the group
    if (node.group) {
        return safeRound(value) !== 100;
    }

    return false;
};
